(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name print.controller:PrintCtrl
     *
     * @description
     *
     */
    angular
        .module('print')
        .controller('PrintJourneyLogCtrl', PrintCtrl);

    function PrintCtrl($stateParams, PrintService) {
        var vm = this;
        vm.ctrlName = 'PrintJourneyLogCtrl';
        vm.model = {
            blockId: $stateParams.blockId,
            version: $stateParams.version,
            crewScheduleEventId : $stateParams.crewScheduleEventId,
            journeyData:null
        };

        function loadJourneyData(){
            PrintService.getJourneyLogData(vm.model, function (response) {
                vm.model.journeyData = response;
            });
        }

        //Init 
        (function () {
            if (!!$stateParams.blockId) {
                loadJourneyData();
            }
        })()

    }
}());
